import React, { useEffect } from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function Disclaimer() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-475" data-mp="16wk4msfhoio9">
      <SEO title="Disclaimer | KittyPot" description="KittyPot is a shared expense and settlement tracker for expense tracking and manual settlement only. KittyPot does not hold or move money." ogTitle="KittyPot Disclaimer" ogDescription="KittyPot is for expense tracking and manual settlement only — it does not hold or move money." path="/disclaimer" data-id="element-476" data-mp="1av1evku7i99w" />
      <Navbar data-id="element-477" data-mp="rzjmngn3o22z" />
      <main className="pt-32 pb-24" data-id="element-478" data-mp="s02w08yopi5e">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-479" data-mp="3rlzt3gr8jvaq">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-480" data-mp="3rlhwuk4kph2t">
            Disclaimer
          </h1>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-481" data-mp="3vls6q7vhkrmy">
            <p data-id="element-482" data-mp="20m3m3dtpim60">
              This Disclaimer forms part of, and must be read in conjunction
              with, the Website and Mobile Application Terms and Conditions.
              KittyPot Ltd reserves the right to update or amend this Disclaimer
              at any time.
            </p>

            <p data-id="element-483" data-mp="1lxpkf68113r1">
              The information provided on this website and within the KittyPot
              mobile application (together referred to as the "Services") is for
              general information purposes only. The Services are operated by
              https://kittypot.com ("Website") and the KittyPot mobile
              application ("App"), collectively referred to as "KittyPot Ltd",
              "we", "us", or "our".
            </p>

            <p data-id="element-484" data-mp="32cif0jsk3sg2">
              By accessing or using our Services, you acknowledge and agree to
              the following:
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-485" data-mp="2xeyzlgk4h9mj">
              1. MVP Status and Manual Settlement
            </h2>
            <p data-id="element-486" data-mp="vmnej8l8t1pi">
              Current MVP: KittyPot is for expense tracking and manual
              settlement only. KittyPot does not currently hold funds, process
              payments, issue cards, or provide regulated e-money services.
              Users enter and confirm expense information, and KittyPot is not
              responsible for whether group members settle outside the app.
              Balances are based entirely on user-entered data and available
              records.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-487" data-mp="14h24c53efumv">
              2. Accuracy of Information
            </h2>
            <p data-id="element-488" data-mp="19evc32kcowp9">
              While we strive to ensure the information provided through our
              Services is accurate and up to date, we do not guarantee its
              completeness, accuracy, reliability, or timeliness. Any reliance
              you place on such information is strictly at your own risk.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-489" data-mp="2caljzoxnbens">
              3. Limitation of Liability
            </h2>
            <p data-id="element-490" data-mp="2l8xcjwi2omiv">
              To the fullest extent permitted by law, KittyPot Ltd shall not be
              liable for any loss or damage, whether direct, indirect,
              incidental, consequential, or otherwise, arising out of or in
              connection with your use of the Website or App. This includes, but
              is not limited to, financial loss, loss of data, or business
              interruption.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-491" data-mp="22bw0jrq3pm5f">
              4. Availability of Services
            </h2>
            <p data-id="element-492" data-mp="1xhrwphc4tu8k">
              The Website and App are provided on an "as is" and "as available"
              basis. We do not warrant that the Services will always be
              available, uninterrupted, secure, or error-free, or that any
              defects will be corrected.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-493" data-mp="1ngqtis1kiq9c">
              5. No Warranties
            </h2>
            <p data-id="element-494" data-mp="1sfbu4skqfbyb">
              KittyPot Ltd disclaims all warranties, express or implied,
              including but not limited to:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-495" data-mp="1x7vafxat0l6t">
              <li data-id="element-496" data-mp="226evlvhkpsy4">
                Any implied warranties of merchantability or fitness for a
                particular purpose
              </li>
              <li data-id="element-497" data-mp="269bk22tsoj9z">
                Any warranties arising from course of dealing, usage, or trade
              </li>
              <li data-id="element-498" data-mp="2b4iesl536dmr">
                Any warranties that the Services will meet your requirements
              </li>
            </ul>
            <p data-id="element-499" data-mp="gt3r09vmyo9n">
              You assume full responsibility for any risk associated with the
              use of our Services.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-500" data-mp="lrne4dlyu63l">
              6. Third-Party Services
            </h2>
            <p data-id="element-501" data-mp="9h5rtecx83wm">
              Our Services may rely on or link to third-party services,
              platforms, or providers. KittyPot Ltd makes no representations or
              warranties regarding these third parties and accepts no liability
              for their content, availability, or performance.
            </p>
            <p data-id="element-502" data-mp="x707e3omk6kk">
              We will not be liable for any downtime or temporary unavailability
              caused by factors beyond our reasonable control, including
              technical failures or third-party outages.
            </p>

            <p className="mt-8" data-id="element-503" data-mp="nane36wzruqc">
              If you have any questions regarding this Disclaimer, please
              contact us via our website contact form.
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-504" data-mp="32zoqm240nd9i" />
    </div>;
}